// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5040":"e48ee8c5","5978":"590dcdb6","6301":"590dcdb6","8071":"590dcdb6","8660":"590dcdb6","9693":"efc4a784"}[chunkId] + ".chunk.css";
};